import { getMinValue } from "../PurchaseOrdersComponent";
import FormulaLayout from "./FormulaLayout";

import { multiply, sum, subtract } from "lodash";
const MillerTotalAmount = ({
  dispatch,
  net_weight,
  miller_bill_weight,
  unit,
  contract_type,
  miller_advance,
  gst_charge,
  miller_brokerage,
  bri_brokerage,
  rate,
  tds_amount,
  miller_bill_amount,
}) => {
  console.log(miller_brokerage, "miller_brokerage==");
  const finalNetWeight = getMinValue(dispatch, net_weight, miller_bill_weight);

  const brokerage = Number(miller_brokerage ?? 0);
  const rateVal = Number(rate ?? 0);

  const calculatedValue = subtract(
    sum([multiply(finalNetWeight, rateVal), miller_advance, gst_charge]),
    // sum([tds_amount, contract_type === "EX FACTORY" ? brokerage : 0])
    sum([tds_amount, brokerage])
  );

  const finalAmount = getMinValue(miller_bill_amount, calculatedValue).toFixed(2);

  return (
  <FormulaLayout>
    <div style={{ marginBottom: "12px" }}>
      <strong style={{ fontSize: "15px" }}>Miller Total Amount Formula</strong>
    </div>

    <div
      style={{
        padding: "10px 12px",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        fontSize: "13px",
        marginBottom: "10px",
      }}
    >
      {/* Final Net Weight */}
      <div>
        Final Net Weight = min(Dispatch, Net Weight, Miller Bill Weight)
      </div>

      <div style={{ marginTop: "6px", color: "#555" }}>
        = min({dispatch}, {Number(net_weight).toFixed(3)}, {miller_bill_weight})
      </div>

      <div style={{ marginTop: "6px" }}>
        Final Net Weight:{" "}
        <strong>{Number(finalNetWeight).toFixed(3)} {unit}</strong>
      </div>

      {/* Calculation */}
      <div style={{ marginTop: "12px" }}>
        Total Amount = min( Miller Bill Amount, (Final Net Weight × Rate) + GST + Advance − TDS − Miller Brokerage)
      </div>

      <div style={{ marginTop: "6px", color: "#555" }}>
        = min(
        {miller_bill_amount},
        ({Number(finalNetWeight).toFixed(3)} × {rate}) + {gst_charge} +{" "}
        {miller_advance} − {tds_amount} −{" "}
        {brokerage.toFixed(2) || 0})
      </div>

      <div style={{ marginTop: "6px" }}>
        = min({miller_bill_amount}, {Number(calculatedValue).toFixed(2)})
      </div>

      {/* Final Output */}
      <div
        style={{
          marginTop: "10px",
          fontSize: "15px",
          fontWeight: 600,
        }}
      >
        Total Amount: ₹ {finalAmount}
      </div>
    </div>
  </FormulaLayout>
);
};

export default MillerTotalAmount;
